import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Popup from "../../components/Layout/popup";

import agent_vs_visitor from "../../assets/images/itoagent/agent_vs_visitor.png";


const VisitorVSAgent = () => { 
    return (
      <React.Fragment>
        <section>
               
          <Container className="mt-100">
              <Row className="align-items-center">

                  <Col lg={6} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                      <div className="section-title ms-lg-5">
                        <h4 className="title mb-4">Bridge the gap between your team and your customers.</h4>
                        <p className="text-muted">Streamline Customer Engagement: Route requests directly to your agents.</p>
                        <ul className="list-unstyled text-muted">
                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                            Deliver real-time responses to client inquiries.
                          </li>
                          <li className="mb-1">
                            <span className="text-primary h5 me-2">
                              <i className="uil uil-check-circle align-middle"></i>
                            </span>
                              Answer, engage, and boost productivity.
                          </li>
                        </ul>
                        {/**
                        <Link to="#" className="mt-3 h6 text-primary">Find Out More <i className="uil uil-angle-right-b"></i></Link>
                        **/}
                      </div>
                  </Col>

                   <Col lg={6} md={6}>
                      <img  src={agent_vs_visitor} className="img-fluid shadow rounded" alt="" />
                  </Col>

              </Row>
        </Container>

        </section>

      </React.Fragment>
    );
}

export default VisitorVSAgent;
